import { Materials } from '../../CIMSModule/instances'
import { CIMSPageItem } from '../CIMSPageItem'

export const ConcreteMixDesigns = new CIMSPageItem({
  id: '5193606a-bb7f-4fb8-b9ee-41d15e27b07c',
  module: Materials,
  name: 'Concrete',
  pathname: 'concrete-mix-designs',
  linkable: true,
})
export const AsphaltMixDesigns = new CIMSPageItem({
  id: 'ba0d3d04-c244-4b24-94cb-b316406e5b5a',
  module: Materials,
  name: 'Asphalt',
  pathname: 'asphalt-mix-designs',
})
export type MaterialsPageItem =
  | typeof ConcreteMixDesigns
  | typeof AsphaltMixDesigns
